import { observer } from 'mobx-react-lite';

type Props = {
    title: string,
    content: any,
    isLast: boolean
};

export default observer(function TermsCard({ title, content, isLast }: Props) {
    return (
        <div className={`mt-6 ${isLast ? 'mb-6' : ''}`}>
            <div className='text-[15px] font-semibold text-textAccountType break-words'>{title}</div>
            <p className='text-[13px] leading-[15.73px] text-textAccountType mt-3 break-words'>
                {content}
            </p>
        </div>
    );
});
